import React from 'react';
import {
  TopicDiv,
  NewTopic,
  NewButton,
  ActiveTopic,
  NewTopicDesc,
  Desc,
  Wrapper,
  Heading,
  ActiveTopicDiv,
  NewTopicSpan,
  ActiveTopicDiv2,
} from './HomePage.styled';

import { useDispatch, useSelector } from 'react-redux';
import { activeTopicList, resetFlagFunc, setFetchStatus, setPopUpActive } from '../../../../store/redux/slices/topicSlice';
import { useNavigate } from 'react-router-dom';
import { FacebookLogoSmall, HashTagIcon, InstagramIconSmall, X_icon, YouTubeRedIcon } from '../../../../Common/SvgIcon/CommonSvgIcons';
import styled from 'styled-components';
import { AccountCircle } from '@mui/icons-material';


const PinSideLoop = styled.p`
    // display: flex;
    // align-items: center;
    // justify-content: center;
    // gap: 7px;
`;
const SelectHastag = styled.span`
    font-size: 30px;
    margin-right: 5px;
    width: 40px;
    text-align: center;
    color: white;
    display: flex;
    align-items: center;

    & > svg {
    width:20px;
    height:20px;
    }

`;
const SpaninSideLoop = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: -10px;
    left: -10px;
    width: 32px;
    height: 35px;
    border: 2px solid rgba(45, 137, 85, 1);
    border-radius: 20px;
    background: rgba(255, 255, 255, 1);
    & > svg {
      width: 20px;
      height: 20px;
    }
`;

function HomePage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { personalDetailsData } = useSelector((state) => state.tenantSetting);
  const { activeTopicListData } = useSelector((state) => state.topicBuilder) || [];
  if (activeTopicListData === null) {
    dispatch(activeTopicList());
  }

  const handleTopicClick = (job_id) => {
    dispatch(setFetchStatus())
    navigate('/topic/job_' + job_id)

    dispatch(resetFlagFunc(false))
  };

  const handleChangePage = () => {

    dispatch(setPopUpActive(true))
    navigate('/topic/create')
  }
  const activeTopics = activeTopicListData?.filter((topic) => topic.is_active === 0)

  return (
    <Wrapper style={{paddingRight: '0px'}}>
      <TopicDiv heading={(personalDetailsData?.is_custom == 'custom' && personalDetailsData?.heading_accent) ? personalDetailsData?.heading_accent :'#000000'}>Topic Listening</TopicDiv>
      <Desc>Discover brand insights, craft custom reports</Desc>
      <NewTopic>
        <NewTopicSpan>The Advanced Topic Composer</NewTopicSpan>
        <NewTopicDesc>
          Our advanced query builder allows users to create targeted topic
          requests with ease. Seamlessly explore a wide array of filtering
          options, including keywords, hashtags, user mentions, exclusions, and
          more, to fulfil your diverse data needs.
        </NewTopicDesc>
        <NewButton onClick={() => handleChangePage()}
          style={{ background:personalDetailsData?.is_custom == 'custom' && personalDetailsData?.selected_items ? personalDetailsData?.selected_items :'linear-gradient(180deg, #0B7263 0%, #5AA942 100%)'}}>
          New Topic
        </NewButton>
      </NewTopic>
      <ActiveTopic>
        <Heading>Active Topics</Heading>
        <div className='topicWrapper'>
          {activeTopics?.map((el) => (
            <ActiveTopicDiv2
              key={el.job_id}
              onClick={() => handleTopicClick(el.job_id)}
              // style={{justifyContent:'left'}}
              title={el.topic_title}
              channel={el.channel}
            >
              <SpaninSideLoop>{el.channel == 'twitter' ? X_icon : el.channel == 'instagram' ? InstagramIconSmall : el.channel == 'facebook' ? FacebookLogoSmall : el.channel === 'youtube' ? YouTubeRedIcon : <></>}</SpaninSideLoop>
              {el.channel == 'instagram' &&  el.search_type == 'hashtag' ? <SelectHastag>({HashTagIcon})</SelectHastag> :  el.search_type == 'user' ? <SelectHastag style={{display:'flex',alignItems:'center'}}>( {<AccountCircle />} )</SelectHastag> : <></>}
              <PinSideLoop style={{textAlign:'left'}} >
                {el.topic_title}
              </PinSideLoop>
            </ActiveTopicDiv2>
          ))}
        </div>
      </ActiveTopic>
    </Wrapper>
  );
}

export default HomePage;
